import React, { Component } from 'react'
import { Box } from 'reactjs-admin-lte'
import $ from 'jquery'
import { Button, ButtonGroup, FormControl, FormGroup, Form, Tabs, Tab, ButtonToolbar } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import AdminStore from 'stores/AdminStore'
import Select from 'react-select'
import ConfirmPopup from 'component/element/ConfirmPopup'
// import WorkJobAssignTaskModal from '../workdoc/jobcontrol/WorkJobAssignTaskModal'
import EmployeeModal from '../hr/EmployeeModal'

const NotificationSystem = require('react-notification-system')
const durationUnitList = [{label:'-- เลือก --',value:''},{label:'นาที',value:'min'},{label:'ชั่วโมง',value:'hour'},{label:'วัน',value:'day'},{label:'กำหนดเอง',value:'custom'}]
class ConfigOfficeWorkflow extends Component {
    constructor(props) {
      super(props)
      
      this.state = {loading:false,tabKey:0,data:[],oriData:[],office_state:[],isBtnActive:[],users:[{label:'-- เลือก --',value:''}],officeStateList:[],showConfirmDel:false,rKey:undefined,sKey:undefined,showAssign:false,resultTab3:{status:'',data:{},work_status:[]}}
    }
  
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem
        this.loadData()

        $('body').on('click', ()=> { 
            if ($('.Select').hasClass('is-open'))
              $('.table-responsive').css( "overflow-x", "initial" );
            else
              $('.table-responsive').css( "overflow-x", "auto" );
        });
    }

    newEmptyRow(item) {
        return {active:'0',alert:'',department:'',duration:'',duration_unit:'',employee_id:'',first_name:'',label:item.label,last_name:'',nick_name:'',perm_job_owner:false,perm_taking_car:'',position:'',system_user_id:'',task_seq:'',task_value:item.value,warning:''}
    }    

    loadData() {
        this.setState({loading:true})
        AdminStore.loadConfigOfficeWorkflow((result)=>{
            let data = []
            let isBtnActive = []
            let users = [{label:'-- เลือก --',value:''}]
            let officeStateList = []
            users = result.users.map((item,index)=>{
                return {label:item.real_name+' - '+item.userid,value:item.userid}
            })

            let office_state = []
            result.office_state.forEach((ritem,rindex)=>{
                ritem = Object.assign({transferState:['']}, ritem)
                office_state.push(ritem)

                officeStateList.push({label:ritem.label,value:ritem.value})
                let newData = {label:ritem.label,datalist:[]}
                let btnActive = []
                let taskData = []
                let isValue = false
                result.data.forEach((sitem,sindex)=>{
                    if (sitem.task_value==ritem.value) {
                        taskData.push(sitem)
                        isValue = true
                        btnActive.push({
                            duration: false,
                            alert: false
                        })
                    }  
                })
                if (!isValue) {
                    taskData.push(this.newEmptyRow(ritem))
                    btnActive.push({
                        duration: false,
                        alert: false
                    })
                }    
                
                newData.datalist = taskData
                data.push(newData)
                isBtnActive.push(btnActive)
            })
            this.setState({loading:false,data:data,oriData:JSON.parse(JSON.stringify(data)),office_state:office_state,isBtnActive:isBtnActive,users:users,officeStateList:officeStateList})
        })
    }

    loadConfigNotifyWork() {
        this.setState({loading:true})
        AdminStore.loadConfigNotifyWork((result)=>{
            this.setState({resultTab3:result,loading:false})
        })
    }

    onAddClick(rindex) {
        let {data,isBtnActive} = this.state
        let item = {label:data[rindex].label,value:data[rindex].datalist[data[rindex].datalist.length-1].task_value}
        data[rindex].datalist.push(this.newEmptyRow(item))
        isBtnActive[rindex].push({
            duration: false,
            alert: false
        })
        this.setState({data:data,oriData:JSON.parse(JSON.stringify(data)),isBtnActive:isBtnActive})
    }

    afterDel(rindex,sindex) {
        let {data,isBtnActive} = this.state
        if (data[rindex].datalist.length==1) {
            let item = {label:data[rindex].label,value:data[rindex].datalist[data[rindex].datalist.length-1].task_value}
            data[rindex].datalist[sindex] = this.newEmptyRow(item)
            isBtnActive[rindex][sindex].duration = false
            isBtnActive[rindex][sindex].alert = false
        } else {
            data[rindex].datalist.splice(sindex,1)
            isBtnActive[rindex].splice(sindex,1)
        }
        this.setState({data:data,oriData:JSON.parse(JSON.stringify(data)),isBtnActive:isBtnActive})
    }

    onDelClick(rindex,sindex) {
        let {data} = this.state
        if (data[rindex].datalist[sindex].task_seq==''||data[rindex].datalist[sindex].task_seq==undefined||data[rindex].datalist[sindex].task_seq==null) {
            this.afterDel(rindex,sindex)
        } else {
            this.setState({showConfirmDel:true,rKey:rindex,sKey:sindex})
        }
    }    

    onConfirmDelClick() {
        let {data,rKey,sKey} = this.state
        AdminStore.delConfigOfficeWorkflow(data[rKey].datalist[sKey].task_seq,(result)=>{
            if (result.status=='OK') {
                this.afterDel(rKey,sKey)
                this.onConfirmHideClick()
            }
        })
    }

    onConfirmHideClick() {
        this.setState({showConfirmDel:false,rKey:undefined,sKey:undefined})
    }

    onAssignTaskSave(items) {
        let {data,rKey,sKey} = this.state
        data[rKey].datalist[sKey].employee_id = items.employee_id
        data[rKey].datalist[sKey].first_name = items.first_name
        data[rKey].datalist[sKey].last_name = items.last_name
        data[rKey].datalist[sKey].nick_name = items.nick_name
        this.setState({data:data,rKey:undefined,sKey:undefined,showAssign:false},()=>{
            this.onSaveClick(rKey,sKey)
        })
    }

    onInputChange(rindex,sindex,field,e) {
        let {data} = this.state
        data[rindex].datalist[sindex][field] = e.target.value
        this.setState({data:data},()=>{
            this.onInputFocus(rindex,sindex,field)
        })
    }

    onInputFocus(rindex,sindex,field) {
        let {data,oriData,isBtnActive} = this.state
        let oriVal = oriData[rindex].datalist[sindex][field]
        let newVal = data[rindex].datalist[sindex][field]
        if (oriVal==newVal)
            isBtnActive[rindex][sindex][field] = false
        else
            isBtnActive[rindex][sindex][field] = true
        this.setState({isBtnActive:isBtnActive})
    }

    onDurationUnitChange(rindex,sindex,e) {
        let {data} = this.state
        data[rindex].datalist[sindex].duration_unit = e.value
        this.setState({data:data})
        this.onSaveClick(rindex,sindex)
    }

    onActiveClick(rindex,sindex) {
        let {data} = this.state
        if (data[rindex].datalist[sindex].active=='1')
            data[rindex].datalist[sindex].active = '0'
        else
            data[rindex].datalist[sindex].active = '1'
        this.setState({data:data})
        this.onSaveClick(rindex,sindex)
    }

    onSystemUserIdChange(rindex,sindex,e) {
        let {data} = this.state
        data[rindex].datalist[sindex].system_user_id = e.value
        this.setState({data:data})
        this.onSaveClick(rindex,sindex)
    }

    onOfficeStateListChange(rindex,sindex,e) {
        let {office_state} = this.state
        office_state[rindex].transferState[sindex] = e.value
        this.setState({office_state:office_state})
        this.onSaveConfigOfficeState(rindex)
    }

    onSaveClick(rindex,sindex,field='') {
        let {data} = this.state
        let postData = data[rindex].datalist[sindex]
        if (postData.employee_id==''||postData.employee_id==undefined||postData.employee_id==null) {
            this._notificationSystem.addNotification({
                title: 'แจ้งเตือน',
                message: 'กรุณาเลือกพนักงาน !',
                level: 'error',
                position: 'tc',        
              })
            return false
        }

        AdminStore.saveConfigOfficeWorkflow(postData.task_seq,postData,(result)=>{
            if (result.status=='OK') {
                this._notificationSystem.addNotification({
                    title: 'แจ้งเตือน',
                    message: 'ทำการบันทึกเรียบร้อย',
                    level: 'info',
                    position: 'tc',        
                })
                data[rindex].datalist[sindex].task_seq = result.task_seq
                this.setState({data:data,oriData:JSON.parse(JSON.stringify(data))},()=>{
                    if (field=='duration'||field=='alert')
                        this.onInputFocus(rindex,sindex,field)
                })
            } else {
                this._notificationSystem.addNotification({
                    title: 'แจ้งเตือน',
                    message: 'บันทึกข้อมูลเข้าระบบมีปัญหา โปรดลองอีกครั้ง',
                    level: 'error',
                    position: 'tc',        
                  })
                return false
            }
        })
    }

    onSaveConfigOfficeState(rindex) {
        let {office_state} = this.state
        let postData = {task_value:office_state[rindex].value,transferState:office_state[rindex].transferState}
        AdminStore.saveConfigOfficeState(postData,(result)=>{
            if (result.status=='OK') {
                this._notificationSystem.addNotification({
                    title: 'แจ้งเตือน',
                    message: 'ทำการบันทึกเรียบร้อย',
                    level: 'info',
                    position: 'tc',        
                })
            } else {
                this._notificationSystem.addNotification({
                    title: 'แจ้งเตือน',
                    message: 'บันทึกข้อมูลเข้าระบบมีปัญหา โปรดลองอีกครั้ง',
                    level: 'error',
                    position: 'tc',        
                  })
                return false
            }
        })
    }

    onTabsSelect(e) {
        if (e==2) {
            this.loadConfigNotifyWork()
        }
        this.setState({tabKey:e})
    }

    onAddOfficeStateClick(rindex) {
        let {office_state} = this.state
        office_state[rindex].transferState.push('')
        this.setState({office_state:office_state})
    }

    onDelOfficeStateClick(rindex,sindex) {
        let {office_state} = this.state
        if (office_state[rindex].transferState.length==1) {
            office_state[rindex].transferState = ['']
        } else if (office_state[rindex].transferState.length>1) {
            office_state[rindex].transferState.splice(sindex,1)
        }
        this.setState({office_state:office_state})
        
    }

    onTextChange(index,key,field,e) {
        let {resultTab3} = this.state
        resultTab3.data[index][key][field] = e.target.value
        this.setState({resultTab3:resultTab3})
    }

    onNotiStatusChange(index,key,e) {
        let {resultTab3} = this.state
        let notiVal = resultTab3.data[index][key]
        let newObj = {[e.value]: notiVal}
        resultTab3.data[index] = newObj
        this.setState({resultTab3:resultTab3})
    }

    onTab3SaveClick() {
        this.setState({loading:true})
        let {resultTab3} = this.state
        let postData = {notify_work:resultTab3.data}
        AdminStore.saveConfigNotifyWork(postData,(resutl)=>{
            if (resutl.status=='OK') {
                this.setState({loading:false})
                this._notificationSystem.addNotification({
                    title: 'แจ้งเตือน',
                    message: 'ทำการบันทึกเรียบร้อย',
                    level: 'info',
                    position: 'tc',        
                })
            } else {
                this.setState({loading:false})
            }
        },()=>{
            this.setState({loading:false})
        })
    }

    renderRowData() {
        let {data,users,isBtnActive} = this.state
        if (data.length==0) {
            return(<tr><td colSpan={7}>ไม่พบข้อมูล</td></tr>)
        } else {
            return(
                data.map((ritem,rindex)=>{
                    return(
                        ritem.datalist.map((sitem,sindex)=>{
                            let title = '(ไม่ระบุชื่อ)'
                            if (sitem.employee_id!='')
                                title = sitem.first_name+' '+sitem.last_name
                            return(
                                <tr key={rindex+'-'+sindex}>
                                    {sindex==0?<td rowSpan={ritem.datalist.length} className='text-center' style={{verticalAlign:'middle'}}>{ritem.label}</td>:''}
                                    <td className='text-center'>
                                        <Button bsStyle='link' onClick={()=>{this.setState({showAssign:true,rKey:rindex,sKey:sindex})}}>
                                            <FontAwesome name='pencil' />&nbsp;{title}
                                        </Button>
                                        <div className='text-right' style={{position:'relative',cursor:'pointer'}}>
                                            {sindex==0?<FontAwesome style={{position:'absolute',bottom:'-5px',right:(sindex==0&&sitem.task_seq!=''?'30px':'0')}} onClick={this.onAddClick.bind(this,rindex)} className='color-green' name='plus' />:''}
                                            {(sindex>0)||(sindex==0&&sitem.task_seq!='')?<FontAwesome style={{position:'absolute',bottom:'-5px',right:'0'}} onClick={this.onDelClick.bind(this,rindex,sindex)} className='color-red' name='minus' />:''}
                                        </div>
                                    </td>
                                    <td className='text-left'>
                                        <Select 
                                            placeholder='-- เลือก --'
                                            clearable={false}
                                            value={sitem.system_user_id}
                                            options={users}
                                            onChange={this.onSystemUserIdChange.bind(this,rindex,sindex)}
                                        />
                                    </td>
                                    <td className='text-center'>
                                        <Form inline>
                                            <FormGroup>
                                                <FormControl className='text-center' style={{width:'80px'}} value={sitem.duration} onChange={this.onInputChange.bind(this,rindex,sindex,'duration')} onFocus={this.onInputFocus.bind(this,rindex,sindex,'duration')} />
                                            </FormGroup>{' '}
                                            <Button onClick={this.onSaveClick.bind(this,rindex,sindex,'duration')} style={{display:(isBtnActive[rindex][sindex].duration?'':'none')}} bsSize='sm' bsStyle='success'><FontAwesome name='save' />&nbsp;บันทึก</Button>
                                        </Form>
                                    </td>
                                    <td className='text-left'>
                                        <Select 
                                            clearable={false}
                                            value={sitem.duration_unit}
                                            options={durationUnitList}
                                            onChange={this.onDurationUnitChange.bind(this,rindex,sindex)}
                                        />
                                    </td>
                                    <td className='text-center'>
                                        <Form inline>
                                            <FormGroup>
                                                <FormControl className='text-center' style={{width:'80px'}} value={sitem.alert} onChange={this.onInputChange.bind(this,rindex,sindex,'alert')} onFocus={this.onInputFocus.bind(this,rindex,sindex,'alert')} />
                                            </FormGroup>{' '}
                                            <Button onClick={this.onSaveClick.bind(this,rindex,sindex,'alert')} style={{display:(isBtnActive[rindex][sindex].alert?'':'none')}} bsSize='sm' bsStyle='success'><FontAwesome name='save' />&nbsp;บันทึก</Button>
                                        </Form>
                                    </td>
                                    <td className='text-center'>
                                        <ButtonGroup
                                            onClick={this.onActiveClick.bind(this,rindex,sindex)}
                                        >
                                            <Button value={0} bsStyle={sitem.active=='0'?'danger':'default'}>ปิด</Button>
                                            <Button value={1} bsStyle={sitem.active=='1'?'success':'default'}>เปิด</Button>
                                        </ButtonGroup>
                                    </td>
                                </tr>
                            )
                        })
                    )
                })    
            )
        }
    }

    renderRowData2() {
        let {officeStateList,office_state} = this.state
        if (office_state.length==0) {
            return(<tr><td colSpan={2}>ไม่พบข้อมูล</td></tr>)
        } else {
            return(
                office_state.map((ritem,rindex)=>{
                    return(
                        ritem.transferState.map((sitem,sindex)=>{
                            let stateList = [{label:'-- เลือก --',value:''}]
                            officeStateList.forEach((item,index)=>{
                                if (item.value!=ritem.value)
                                    stateList.push({label:item.label,value:item.value})
                            })
                            return(
                                <tr key={rindex+'-'+sindex}>
                                    {sindex==0?<td rowSpan={ritem.transferState.length} className='text-center' style={{verticalAlign:'middle'}}>{ritem.label}</td>:''}
                                    <td className='text-left'>
                                        <Select 
                                            placeholder='-- เลือก --'
                                            clearable={false}
                                            value={sitem}
                                            options={stateList}
                                            onChange={this.onOfficeStateListChange.bind(this,rindex,sindex)}
                                        />
                                        <br/>
                                        <div className='text-right' style={{position:'relative',cursor:'pointer'}}>
                                            {sindex==0?<FontAwesome style={{position:'absolute',bottom:'-5px',right:(sindex==0&&sitem!=''?'30px':'0')}} onClick={this.onAddOfficeStateClick.bind(this,rindex)} className='color-green' name='plus' />:''}
                                            {(sindex>0)||(sindex==0&&sitem!='')?<FontAwesome style={{position:'absolute',bottom:'-5px',right:'0'}} onClick={this.onDelOfficeStateClick.bind(this,rindex,sindex)} className='color-red' name='minus' />:''}
                                        </div>
                                    </td>
                                </tr>
                            )
                        })
                    )
                })
            )
        }
    }         
    
    renderRowData3() {
        let {resultTab3} = this.state
        let data = Object.keys(resultTab3.data)
        return(
            data.map((item,index)=>{
                let statusKey = resultTab3.work_status.findIndex(x=>x.status==item)
                let notiKey = undefined
                for (var i in resultTab3.data[item]) {
                    notiKey = i
                }
                return(
                    <tr key={index}>
                        <td className='text-center'>{resultTab3.work_status[statusKey].title}</td>
                        <td className='text-center'>
                            <Select 
                                placeholder='-- เลือก --'
                                clearable={false}
                                value={notiKey}
                                options={[{label:'แจ้งเตือนภายในวัน (นาที)',value:'in_minutes'},{label:'แจ้งเตือนตั้งแต่รับรถครั้งแรก (วัน)',value:'in_enter_days'},{label:'แจ้งเตือนตั้งแต่อยู่ในสถานะ (วัน)',value:'in_days'}]}
                                onChange={this.onNotiStatusChange.bind(this,item,notiKey)}
                            />
                        </td>
                        <td className='text-center'><FormControl className='text-center' onChange={this.onTextChange.bind(this,item,notiKey,'warning')} value={resultTab3.data[item][notiKey].warning} /></td>
                        <td className='text-center'><FormControl className='text-center' onChange={this.onTextChange.bind(this,item,notiKey,'danger')} value={resultTab3.data[item][notiKey].danger} /></td>
                    </tr>    
                )
            })
        )
    }

    renderTable() {
        return(
            <div className='table-responsive'>
                <table className='table table-hover table-bordered-solid'>
                    <thead>
                        <tr>
                            <th style={{width:'100px'}} className='text-center'>ประเภทงาน</th>
                            <th style={{width:'150px'}} className='text-center'>พนักงาน</th>
                            <th style={{width:'130px'}} className='text-center'>User ในระบบ</th>
                            <th style={{width:'80px'}} className='text-center'>กำหนดเวลาเสร็จ</th>
                            <th style={{width:'80px'}} className='text-center'>หน่วยเวลา</th>
                            <th style={{width:'80px'}} className='text-center'>แจ้งเตือนก่อนเวลา</th>
                            <th style={{width:'60px'}} className='text-center'>สถานะการใช้งาน</th>
                        </tr>    
                    </thead>    
                    <tbody>
                        {this.renderRowData()}
                    </tbody>
                </table>
            </div>
        )
    }

    renderTable2() {
        return(
            <div className='table-responsive'>
                <table className='table table-hover table-bordered-solid'>
                    <thead>
                        <tr>
                            <th style={{width:'150px'}} className='text-center'>ประเภทงาน</th>
                            <th style={{width:'150px'}} className='text-center'>ส่งต่องาน</th>
                        </tr>    
                    </thead>    
                    <tbody>
                        {this.renderRowData2()}
                    </tbody>
                </table>
            </div>
        )
    }

    renderTable3() {
        return(
            <div className='table-responsive'>
                <table className='table table-hover table-bordered-solid'>
                    <thead>
                        <tr>
                            <th style={{width:'150px'}} className='text-center'>สถานะใบจ็อบ</th>
                            <th style={{width:'150px'}} className='text-center'>ประเภทแจ้งเตือน</th>
                            <th style={{width:'150px'}} className='text-center'>แจ้งเตือนก่อนเวลา</th>
                            <th style={{width:'150px'}} className='text-center'>กำหนดเวลาเสร็จ</th>
                        </tr>    
                    </thead>    
                    <tbody>
                        {this.renderRowData3()}
                    </tbody>
                </table>
            </div>
        )
    }

    render() {
        let {loading,tabKey} = this.state
        return(
            <div>
                <Tabs onSelect={this.onTabsSelect.bind(this)} activeKey={tabKey} id='config-office'>
                    <Tab eventKey={0} title='ตั้งค่าพนักงานงานภายในออฟฟิศ'>
                        <Box loading={loading}>
                            <Box.Body>
                                {this.renderTable()}
                            </Box.Body>
                        </Box>
                    </Tab>
                    <Tab eventKey={1} title='ตั้งค่าส่งต่องาน'>
                        <Box loading={loading}>
                            <Box.Body>
                                {this.renderTable2()}
                            </Box.Body>
                        </Box>
                    </Tab>
                    <Tab eventKey={2} title='ตั้งค่าระยะเวลาสถานะใบจ็อบ'>
                        <Box loading={loading}>
                            <Box.Body>
                                {this.renderTable3()}
                            </Box.Body>
                            <Box.Footer>
                                <ButtonToolbar className='pull-right'>
                                    <Button bsStyle='primary' onClick={this.onTab3SaveClick.bind(this)}><FontAwesome name='save' />&nbsp;บันทึก</Button>
                                </ButtonToolbar>
                            </Box.Footer>
                        </Box>
                    </Tab>
                </Tabs>
                <EmployeeModal 
                    show={this.state.showAssign} 
                    onSelect={this.onAssignTaskSave.bind(this)} 
                    onHide={()=>{this.setState({showAssign:false,rKey:undefined,sKey:undefined})}}
                />
                <ConfirmPopup
                    show={this.state.showConfirmDel}
                    message='ต้องการลบรายการทิ้งหรือไม่ ?'
                    onConfirm={this.onConfirmDelClick.bind(this)}
                    onHide={this.onConfirmHideClick.bind(this)}
                />
                <NotificationSystem ref="notificationSystem" />  
            </div>           
        )
    }
}
    
ConfigOfficeWorkflow.defaultProps = {
        
}
      
export default ConfigOfficeWorkflow;      


// WEBPACK FOOTER //
// ./src/view/admin/ConfigOfficeWorkflow.js